<template>
    <div>
        <h4>Preview</h4>
        <elements-category :templateStyle="templateStyle"></elements-category>
    </div>
</template>

<script type="text/babel">
import ElementsCategory from '../Workspace/Available/Category/Elements/ElementsCategory';
export default {
    name: 'TemplatePreview',
    data () {
        return {};
    },
    props: {
        templateStyle: {
            type: Object,
            required: true
        }
    },
    components: {
        ElementsCategory
    }
};

</script>
